import React from "react";
import { IoClose } from "react-icons/io5";

interface FeedbackFormProps {
  feedback: string;
  setFeedback: (feedback: string) => void;
  setShowFeedbackModal: (show: boolean) => void;
  handleFeedbackSubmit: () => void;
}

const FeedbackForm: React.FC<FeedbackFormProps> = ({
  feedback,
  setFeedback,
  setShowFeedbackModal,
  handleFeedbackSubmit,
}) => {
  return (
    <div className="modal">
      <div className="feedback-modal-content">
        <button
          className="modal-close-button"
          onClick={() => setShowFeedbackModal(false)}
        >
          <IoClose size={18} />
        </button>
        <h2 className="modal-title">Your Feedback & Wishlist</h2>
        <label className="modal-label">
          <strong>We value your input:</strong>
        </label>
        <textarea
          className="feedback-modal-input"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          rows={5}
        />
        <button className="modal-button-left" onClick={handleFeedbackSubmit}>
          Send
        </button>
      </div>
    </div>
  );
};

export default FeedbackForm;
